import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Clock, Layers, ListChecks, Info } from "lucide-react";

const TIERS = [
  {
    icon: ListChecks,
    name: "Category-Based Certification",
    time: "5–10 business days",
    note: "after payment and complete document submission",
    testId: "timeline-category",
  },
  {
    icon: Layers,
    name: "Full WECH-RB Certification",
    time: "15 business days",
    note: "after payment and complete document submission",
    testId: "timeline-full",
  },
];

// Reusable "Estimated Review Timeline" block. Pass a wrapper className for spacing.
export const ReviewTimeline = ({ className = "" }) => (
  <div className={className} data-testid="review-timeline">
    <div className="mb-2 flex items-center gap-2">
      <Clock className="h-5 w-5 text-wgreen-700" />
      <h2 className="font-heading text-xl font-semibold text-navy-900">Estimated Review Timeline</h2>
    </div>
    <p className="mb-5 max-w-2xl text-sm text-[var(--wechr-muted-text)]">
      Typical turnaround once your payment is confirmed and all required documents are submitted.
    </p>
    <div className="grid gap-6 md:grid-cols-2">
      {TIERS.map((t) => (
        <Card key={t.name} data-testid={t.testId}>
          <CardContent className="flex items-start gap-4 p-6">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-wgreen-100">
              <t.icon className="h-5 w-5 text-wgreen-700" />
            </div>
            <div>
              <p className="font-heading text-sm font-semibold text-navy-900">{t.name}</p>
              <p className="mt-1 font-heading text-2xl font-bold text-navy-900">{t.time}</p>
              <p className="mt-1 text-xs text-[var(--wechr-muted-text)]">Estimated {t.note}.</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
    <div className="mt-5 flex items-start gap-3 rounded-xl border border-[var(--wechr-border)] bg-[var(--wechr-subtle)] p-4">
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-navy-700" />
      <p className="text-sm leading-relaxed text-navy-800">
        Applications with missing documents, unclear evidence, or required clarification may take longer.
        If documents are missing, the WECH-RB review team will contact the applicant to confirm whether the
        missing documents can be submitted before making a final decision.
      </p>
    </div>
  </div>
);

export default ReviewTimeline;
